import React from 'react';

const OfferSectionContext = React.createContext(null);
export const OfferSectionProvider = OfferSectionContext.Provider;
export default OfferSectionContext;